<div class="lense-dialog__container">
  <h2>
    @if (lensHasId) {
      <mat-icon svgIcon="pencil-outline"></mat-icon>
      Edit Lens
    } @else {
      <mat-icon svgIcon="plus"></mat-icon>
      Create Lens
    }
  </h2>

  <div class="lense-dialog__input-container">
    <oph-input-orange
      [control]="$any(lensFg.get('title'))"
      [inputStyle]="{height: '50px', fontSize: '16px'}"
      placeholder="Lens title"
    />
    @if (lensFg.get('title')?.errors?.['duplicateName']) {
      <span class="lense-dialog__error-message">A lens with this name already exists.</span>
    }
  </div>

  <oph-dialog-footer
    [labels]="footerActionLabels()"
    [menuOptions]="$any(menuOptions)"
    [hideMenu]="!lensHasId"
    [loading]="isLoading"
    (cancel)="onCancel()"
    (save)="onSave()"
    (menuOption)="onMenuOption($event)"
  />
</div>
